<div class="flex flex-col xl:grid xl:grid-cols-2 xl:gap-x-2">
    <p class="xl:col-span-1 text-xl">
        <span class="font-medium">Latitude:</span> {{ getLatitudeLabel() }}
    </p>
    <p class="xl:col-span-1 text-xl">
        <span class="font-medium">Longitude:</span> {{ getLongitudeLabel() }}
    </p>
    <p class="xl:col-span-1 text-xl">
        <span class="font-medium">Frequency:</span> {{ getFrequencyLabel() }}
    </p>
    <p class="xl:col-span-1 text-xl">
        <span class="font-medium">Radius:</span>
        {{ getRadiusLabel() }}
    </p>
    <p class="xl:col-span-1 text-xl">
        <span class="font-medium">Antenna Height (m):</span>
        {{ getAntennaHeightLabel() }}
    </p>
    <p class="xl:col-span-2 text-xl overflow-x-hidden">
        <span class="font-medium">Emission Designators: </span>

        @if (needsEmissionDesignatorsTooltip()) {
            <span
                [matTooltip]="getEmissionDesignatorsTooltip()"
                matTooltipPosition="right"
                >{{ getEmissionDesignatorsLabel() }}</span
            >
        } @else {
            {{ getEmissionDesignatorsLabel() }}
        }
    </p>
</div>
